'use client';

import classes from './FullScreenVideo.module.scss';
import { Box } from '@mantine/core';
import { useAOS } from '@/src/lib/hooks/useAOS';
import Image from 'next/image';

type FullscreenVideoProps = {
  src: string;         // .mp4 video
  poster: string;      // fallback image
  title: string;
  subtitle: string;
  name: string;
  subtitle2: string;
  absolute?: boolean;
  bgMask?: boolean;
};

const FullscreenVideo = ({ data }: { data: FullscreenVideoProps }) => {
  const { src, poster, title, subtitle, name, subtitle2, absolute = true, bgMask } = data;
  useAOS();

  const containerClass = [
    classes.box,
    absolute ? classes.absolute : classes.relative,
    bgMask ? classes.bgMask : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <>
      {absolute && <div className={classes.padding} />}
      <Box className={containerClass}>
        <video
          className={classes.background}
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          poster={poster}
        >
          <source src={src} type="video/mp4" />
          <Image
            src={poster}
            alt="Fallback background"
            //@ts-ignore
            fill
            className={classes.background}
            style={{ objectFit: 'cover' }}
          />
        </video>

        <div className={classes.content} data-aos="zoom-in">
          <div className={classes.name} data-aos="fade-up">
            {name}
          </div>
        </div>
      </Box>
    </>
  );
};

export default FullscreenVideo;
